import React, { Component } from 'react';

//import Filter from 'lodash/filter';
import PropTypes from 'prop-types';
import * as axios from 'axios';
import $ from 'jquery';

import Each from 'lodash/each';
import Filter from 'lodash/filter';
import Merge from 'lodash/merge';
import Map from 'lodash/map';
import Reduce from 'lodash/reduce';
import uniqBy from 'lodash/uniqBy';
import loadImage from 'image-promise';
import ReactDOM from 'react-dom';
import Modal from 'react-modal';
import Dropdown from 'react-dropdown';
import './FindYourCounselor.scss';

//declare var jquery: any;
//declare var $: JQueryStatic;
Modal.defaultStyles.overlay.backgroundColor = 'rgba(0,0,0,.8)';
const customStyles = {
  content : {
    top                   : '50%',
    left                  : '50%',
    right                 : 'auto',
    bottom                : 'auto',
    marginRight           : '-50%',
    transform             : 'translate(-50%, -50%)'
  }
};

let defaultStates = {
    "AL": "Alabama",
    "AK": "Alaska",
    "AS": "American Samoa",
    "AZ": "Arizona",
    "AR": "Arkansas",
    "CA": "California",
    "CO": "Colorado",
    "CT": "Connecticut",
    "DE": "Delaware",
    "DC": "District Of Columbia",
    "FM": "Federated States Of Micronesia",
    "FL": "Florida",
    "GA": "Georgia",
    "GU": "Guam",
    "HI": "Hawaii",
    "ID": "Idaho",
    "IL": "Illinois",
    "IN": "Indiana",
    "IA": "Iowa",
    "KS": "Kansas",
    "KY": "Kentucky",
    "LA": "Louisiana",
    "ME": "Maine",
    "MH": "Marshall Islands",
    "MD": "Maryland",
    "MA": "Massachusetts",
    "MI": "Michigan",
    "MN": "Minnesota",
    "MS": "Mississippi",
    "MO": "Missouri",
    "MT": "Montana",
    "NE": "Nebraska",
    "NV": "Nevada",
    "NH": "New Hampshire",
    "NJ": "New Jersey",
    "NM": "New Mexico",
    "NY": "New York",
    "NC": "North Carolina",
    "ND": "North Dakota",
    "MP": "Northern Mariana Islands",
    "OH": "Ohio",
    "OK": "Oklahoma",
    "OR": "Oregon",
    "PW": "Palau",
    "PA": "Pennsylvania",
    "PR": "Puerto Rico",
    "RI": "Rhode Island",
    "SC": "South Carolina",
    "SD": "South Dakota",
    "TN": "Tennessee",
    "TX": "Texas",
    "UT": "Utah",
    "VT": "Vermont",
    "VI": "Virgin Islands",
    "VA": "Virginia",
    "WA": "Washington",
    "WV": "West Virginia",
    "WI": "Wisconsin",
    "WY": "Wyoming"
}

let defaultDataSet = [
  {
    firstname: 'Stephen',
    lastname: 'Eck',
    title: 'Director of University Admissions',
    group: 'Univeristy Admissions',
    email: 'stephen.eck@njit.edu',
    county: [],
    type: [],
    state: []
  },
  {
    firstname: 'Ivan',
    lastname: 'Crego',
    title: 'Admissions Counselor',
    group: 'Undergraduate Admissions Counselors',
    email: 'ivan.e.crego@njit.edu',
    county: [ 'New York City', 'Long Island', 'Westchester NY', 'Connecticut', 'Florida', 'Southern United States'],
    state: ['NY','CT','FL'],
    type: ['undergraduate']
  },
  {
    firstname: 'Alberto ',
    lastname: 'Guichardo',
    title: 'Admissions Counselor',
    group: 'Undergraduate Admissions Counselors',
    email: 'alberto.d.guichardo@njit.edu',
    county: [ 'Camden', 'Cumberland', 'Gloucester', 'Salem Counties', 'Delaware', 'Maryland', 'Virginia', 'West Virginia'],
    state: ['NJ','DE','MD', 'VA'],
    type: ['undergraduate']
  },
  {
    firstname: 'Debbie',
    lastname: 'Gabbidon',
    title: 'Assistant Director',
    group: 'Undergraduate Admissions Counselors',
    email: 'debbie.gabbidon@njit.edu',
    county: [ 'International', 'Essex', 'Hudson and Middlesex Counties', 'Washington DC'],
    state: [ 'NJ' ],
    type: ['undergraduate']
  },
  {
    firstname: 'Miosotis',
    lastname: 'Hernandez',
    title: 'Assistant Director',
    group: 'Undergraduate Admissions Counselors',
    email: 'miosotis.hernandez@njit.edu',
    county: [ 'Bergen and Passaic Counties', 'Rockland County NY', 'Upstate NY', 'New England'],
    state: ['NY', 'NJ'],
    type: ['undergraduate']
  },
  {
    firstname: 'Tony',
    lastname: 'Jackson',
    title: 'Associate Director - Transfer Admissions',
    group: 'Undergraduate Admissions Counselors',
    email: 'anthony.jackson@njit.edu',
    county: [],
    state: ['NJ','CA'],
    type: ['undergraduate', 'transfer']
  },
  {
    firstname: 'Dimana',
    lastname: 'Neykova',
    title: 'Coordinator of Summer/Winter Enrollment & On-Campus Recruitment Events',
    group: 'Undergraduate Admissions Counselors',
    email: 'dimana.neykova@njit.edu',
    county: [],
    state: ['NJ'],
    type: ['undergraduate']
  },
  {
    firstname: 'John',
    lastname: 'Piechnik',
    title: 'Assistant Director',
    group: 'Undergraduate Admissions Counselors',
    email: 'john.piechnik@njit.edu',
    county: ['Atlantic', 'Burlington', 'Cape May', 'Morris', 'Mercer', 'Ocean Counties', 'Eastern Pennsylvania', 'Western United States'],
    state: ['NY','NJ','PA'],
    type: ['undergraduate']
  },
  {
    firstname: 'Adrienne',
    lastname: 'Richardson',
    title: 'Assistant Director',
    group: 'Undergraduate Admissions Counselors',
    email: 'adrienne.richardson@njit.edu',
    county: ['Monmouth', 'Somerset', 'Union', 'Hunterdon', 'Warren', 'Sussex Counties', 'Staten Island', 'Western Pennsylvania', 'Midwestern United States'],
    state: ['NY','NJ','PA'],
    type: ['undergraduate']
  },
  {
    firstname: 'Somil',
    lastname: 'Mehta',
    title: 'Assistant Director of Graduate Admissions - MS applications for the College of Architecture and Design and Newark College of Engineering',
    group: 'Graduate Admissions',
    email: 'somil.r.mehta@njit.edu',
    county: [],
    state: ['NJ'],
    type: ['graduate']
  },
  {
    firstname: 'Nancy',
    lastname: 'Vega',
    title: 'Associate Director of Graduate Admissions - MS applications for the Ying Wu College of Computing Sciences, College of Science and Liberal Arts and the School of Management',
    group: 'Graduate Admissions',
    email: 'nancy.vega@njit.edu',
    county: [],
    state: ['NJ'],
    type: ['graduate']
  }
]; 


Modal.setAppElement('body');

declare var document:any;

class FindYourCounselor extends Component {
  
  getTermFacets(params = []) {

    let paramsBody = {
      'from': (this.props.from)? parseInt(this.props.from, 10): 0,
      'size': (this.props.size)? parseInt(this.props.size, 10): 1,
      "aggs" : {}
    };
    Each(params, (data,key) => {
      paramsBody.aggs[data] = { 
        terms: {
          field: data,
          size: 1000
        }
      }
    });
    return axios({
      method: 'POST',
      url: '/search-api/news/news/_search',
      headers: {
        'Content-Type': 'application/json'
      },
      data: JSON.stringify(paramsBody)
    });
  }

  constructor(props) {
    super(props);
    console.log('getStates', this.getStates());


    this.state = {
      modalIsOpen: false,
      clsName: 'closed',
      type_options:[
        { value: '', label: 'Choose type of student' },
        { value: 'undergraduate', label: 'Undergraduate student' },
        { value: 'graduate', label: 'Graduate student' },
        { value: 'transfer', label: 'Transfer student' }
      ],
      state_options: this.getStates(),
      county_options: this.getCounties(), 
      county: { value: '', label: 'Choose County'},
      state: { value: '', label: 'Choose type of State' },
      type: { value: '', label: 'Choose type of Student'},
      showResults: false,
      theResults: defaultDataSet,
      aggregations: {}
    };

    let terms = [
      "people_tags_terms",
      "audience",
      "academic_site_audience_terms",
      "homepage_category_terms",
      "keywords_tags_terms",
      "story_type"];

    let aggs = {};
    this.getTermFacets(terms).then((response) => {
      console.log('response', response);
      if(response.status === 200) {
        aggs = response.data.aggregations;
        console.log('ggs', aggs);
        Each(terms, (d, i) => {
          aggs[d] = Map(aggs[d].buckets, (data, key) => {
            return { value: data.key, label: data.key, count: data.doc_count};
          });
        });
         console.log('ggs', aggs);
        this.setState({aggregations: aggs});
      }
    })
    .catch((error) => {
    //console.log(error);
    });

    this.openModal = this.openModal.bind(this);
    this.afterOpenModal = this.afterOpenModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.showCounty = this.showCounty.bind(this);
    this.showState = this.showState.bind(this);
    this.isValid = this.isValid.bind(this);
    this.showResults = this.showResults.bind(this);
    this.clearResults = this.clearResults.bind(this);
    this.checkResults = this.checkResults.bind(this);
    this.getActiveMenu = this.getActiveMenu.bind(this);

  }

  componentDidMount() {
   
  }
  getStates(data = defaultDataSet) {
    let states = [];
    Each(data, (i, k) => {
      states = states.concat( i.state);
    });
    states = uniqBy(states, function (e) {
      return e;
    });
    states = Map(states, function(e) {
      return {
        value: e,
        label: defaultStates[e]
      }
    });
    states.unshift( { value: '', label: 'Choose State' })
    return states;
  }

  getCounties(data = defaultDataSet){
    let counties = [];
    Each(data, (i, k) => {
      counties = counties.concat(i.county);
    });
    counties = uniqBy(counties, function (e) {
      return e;
    });
    counties.unshift( { value: '', label: 'Choose County' })
    return counties;
  }


  openModal() {
    this.setState({modalIsOpen: true, clsName: 'modal-your-admissions-counselor modal-default open'});
  }

  afterOpenModal() {
    // references are now sync'd and can be accessed.
  //  this.subtitle.style.color = '#f00';
  }

  handleChange(e) {
    var data = {};
    data[e.target.name] = e.target.value;
    this.setState(data);
  }

  handleDropdownChange(id, e) {
    var data = {};
    data[id] = e;
    data = this.filterResultsAndDropdowns(data, id);
    this.setState(data);
  }

  filterResultsAndDropdowns(data, type) {
    var newResultSet = defaultDataSet;
    //filter by type
    if(type === 'type') {
      newResultSet = Filter(newResultSet, (item, key) => {
        if(item.type.indexOf(data.type.value) !== -1 ) {
          return true;
        } else {
          return false;
        }
      });

      data.county = { value: '', label: 'Choose County'};
      data.state =  { value: '', label: 'Choose type of State' };

      
      //reset options
      data.state_options = this.getStates(newResultSet);
     // data.county_options = this.getCounties();
    }

    if(type === 'state') {
      newResultSet = Filter(newResultSet, (item, key) => {
        if(item.type.indexOf(this.state.type.value) !== -1 ) {
          return true;
        } else {
          return false;
        }
      });
      if(data.state.value != '') {
       newResultSet = Filter(newResultSet, (item, key) => {
        if(item.state.indexOf(data.state.value) !== -1 ) {
          return true;
        } else {
          return false;
        }
      });

     }

      /* if(data.state.value !== '') { 
        newResultSet = Filter(newResultSet, (item, key) => {
          if(item.state.indexOf(data.state.value) !== -1 ) {
            return true;
          } else {
            return false;
          }
        });
      }*/
      console.log('data', data, newResultSet);
    
      
      
      data.county = { value: '', label: 'Choose County'};
      //data.state_options = this.getStates(newResultSet);
      data.county_options = this.getCounties(newResultSet); 
    }

    if(type === 'county') {
      newResultSet = Filter(newResultSet, (item, key) => {
        if(item.type.indexOf(this.state.type.value) !== -1 ) {
          return true;
        } else {
          return false;
        }
      });
      if(this.state.state.value != '') {
       newResultSet = Filter(newResultSet, (item, key) => {
        if(item.state.indexOf(this.state.state.value) !== -1 ) {
          return true;
        } else {
          return false;
        }
      });

     }
      if(data.county.value != '') {
       newResultSet = Filter(newResultSet, (item, key) => {
        if(item.county.indexOf(data.county.value) !== -1 ) {
          return true;
        } else {
          return false;
        }
      });

     }
    }
    data.theResults = newResultSet;

/*
    //filter by state
    if(this.state.state.value !== '') { 
      newResultSet = Filter(newResultSet, (item, key) => {
        if(item.state.indexOf(this.state.state.value) !== -1 ) {
          return true;
        } else {
          return false;
        }
      });
    }
    if((this.state.state.value === 'NY' || this.state.state.value ==='PA' || this.state.state.value === 'NJ')) {
      newResultSet = Filter(newResultSet, (item, key) => {
        if(item.county.indexOf(this.state.county.value) !== -1 ) {
          return true;
        } else {
          return false;
        }
      });
    }*/
    return data;
//    this.setState({showResults: true, theResults: newResultSet});
  }

  checkResults() {
    if(this.state.showResults) {
      return 'show-results';
    } else {
      return 'hide-results';
    }
  }

  getActiveMenu(test) {
    if(!test) {
      return 'active';
    } else {
      return 'disabled';
    }
  }

  concatArray(array, glue) {
    var string = Reduce(array, (memo, i, k) => {
      memo = memo + i+glue;
      return memo
    },'')
    return string;
  }

  showResults() {
    /*var newResultSet = defaultDataSet;
    //filter by type
    newResultSet = Filter(newResultSet, (item, key) => {
      if(item.type.indexOf(this.state.type.value) !== -1 ) {
        return true;
      } else {
        return false;
      }
    });

    //filter by state
    
    if(this.state.state.value !== '') { 
      newResultSet = Filter(newResultSet, (item, key) => {
        if(item.state.indexOf(this.state.state.value) !== -1 ) {
          return true;
        } else {
          return false;
        }
      });
    }
    if((this.state.state.value === 'NY' || this.state.state.value ==='PA' || this.state.state.value === 'NJ')) {
      newResultSet = Filter(newResultSet, (item, key) => {
        if(item.county.indexOf(this.state.county.value) !== -1 ) {
          return true;
        } else {
          return false;
        }
      });
    }
    console.log('newResultSet', newResultSet);
    */
    this.setState({showResults: true});
  }

  clearResults() {
    this.setState({showResults: false});
  }

  showDropdown(type){
    if(typeof this.state.aggregations[type] !== 'undefined') {
      return (
        <div className="form-filters">
                  <div className="item item-county">
                    <label className="label">and I'm from this {type}:</label>
                    <Dropdown value={this.state[type]} name="{type}" 
                      className='component-dropdown' options={this.state.aggregations[type]} placeholder={'Select a '+type} /> 
                  
                  </div>

                </div>)
    } else {
      return null;
    }
  }

  showState() {
    if(this.state.type.value !== '') {
      return (
        <div className="form-filters">
                  <div className="item item-county">
                    <label className="label">and I'm from this state:</label>
                    <Dropdown value={this.state.state} name="state" onChange={ (e) => this.handleDropdownChange('state', e)}
                      className='component-dropdown' options={this.state.state_options} placeholder="Select a State" /> 
                  
                  </div>

                </div>)
    } else {
      return null;
    }
  }
  showCounty() {
    if((this.state.state.value === 'NY' || this.state.state.value ==='PA' || this.state.state.value === 'NJ') && this.state.county_options.length >1) {
      return (
        <div className="form-filters">
                  <div className="item item-county">
                    <label className="label">and I'm interested in this county:</label>
                    <Dropdown value={this.state.county} name="county" onChange={ (e) => this.handleDropdownChange('county', e)} 
                    className='component-dropdown' options={this.state.county_options} placeholder="Select a County" /> 
                  
                  </div>

                </div>)
    } else {
      return null;
    }
  }

  isValid() {
    if($.trim(this.state.type.value) !== '') {
      /*if(this.state.state.value === 'NY' || this.state.state.value ==='PA' || this.state.state.value === 'NJ') {
        return true;
      } else {
        return false;
      }*/
      return false;
    } else {
      return true;
    }
  }

  closeModal() {
    this.setState({modalIsOpen: false, clsName: 'modal-your-admissions-counselor modal-default closed'});
  }


 
  render() {
    return (

<div className="find-your-counselor">
<div className="find-your-admissions-counselor">

        <Modal

          isOpen={this.state.modalIsOpen}
          onAfterOpen={this.afterOpenModal}
          onRequestClose={this.closeModal}
          style={customStyles}
          contentLabel="Example Modal"
          portalClassName={this.state.clsName}
        >
          <div className="close-btn" onClick={this.closeModal}>close</div>
          
          <div id="your_admissions_counselor" ref={subtitle => this.subtitle = subtitle}>
      <div className={'modal-your-admissions-counselor ' + this.checkResults()}>
        <div className="lb">
        <div className="lb-header">
          <h3 className="title">Your Admissions Counselor</h3>
        </div>
        <div className="lb-body">
          <div className="form-box">

            <div className="first-col">
              <ul className="form-progress-nav">
                <li onClick={this.clearResults} className={'step-about-you '+this.getActiveMenu(this.state.showResults)}>
                  <div>STEP 1: About You</div>
                  <i className="fa fa-check-circle"></i>
                </li>
                <li className={'step-finish '+this.getActiveMenu(!this.state.showResults)}>
                  <div>STEP 2: Finish</div>
                  <i className="fa fa-check-circle"></i>
                </li>
              </ul>
            </div>

            <div className="second-col">
              <div className="section-about-you">
                <h3 className="title">Find the NJIT Admissions Counselor who is best equipped to help you answer any of your questions.</h3>
                <div className="form-filters">
                  <div className="item item-student">
                    <label className="label">I'm a prospective:</label>
                    <Dropdown value={this.state.type} name="type" onChange={ (e) => this.handleDropdownChange('type', e) } className='component-dropdown' options={this.state.type_options} placeholder="Select an option" /> 
                  </div>
                </div>
                {this.showState()}
                {this.showCounty()}

                {this.showDropdown('audience')}
                {this.showDropdown('academic_site_audience_terms')}
                
                <div className="form-actions">
                  <button className="find primary" onClick={this.showResults} disabled={this.isValid()} >FIND YOUR COUNSELOR</button>
                </div>
              </div>

              <div className="section-results">
              <h3 className="title">Results</h3>
              <table className="resultTable"> 
              <tbody> 
              {this.state.theResults.map((d,i) =>
                <tr key={i}>
                  <td>{d.firstname} {d.lastname}</td>
                  <td>{d.title}<br/>
                  {this.concatArray(d.county, ', ')}<br/>
                  {this.concatArray(d.state, ', ')}</td>
                  <td>{d.email}</td>
                </tr>
              )}
              </tbody> 
              </table>
              </div>

              <div className="section-finish" style={{"display": "none" }}>
                <div className="grey-bg"></div>
                <div className="step-back">
                  <a href="javascript: void(0);">Start Over</a>
                </div>
                <div className="summary">
                  <div className="img">
                    <img src="../../img/user-placeholder.png" alt="" />
                  </div>

                  <div className="info clearfix">
                    <div className="name">Adrienne Richardson</div>
                    <div className="position">Assistant Director</div>
                    <div className="contact clearfix">
                      <div className="contact1">
                        <div className="email clearfix">
                          <div className="icon"><i className="fa fa-envelope"></i></div>
                          <div className="content"><a href="mailto:adrienne.richardson@njit.edu" className="link">adrienne.richardson@njit.edu</a></div>
                        </div>
                        <div className="phone clearfix">
                          <div className="icon"><i className="fa fa-phone"></i></div>
                          <div className="preferred">
                            <div className="number"><a href="tel:(973) 596-3304" className="link">(973) 596-3304</a></div>
                            <div className="desc">Preferred</div>
                          </div>
                          <div className="official">
                            <div className="number"><a href="tel:(973) 596-3304" className="link">(973) 596-3304</a></div>
                            <div className="desc">Official</div>
                          </div>
                        </div>
                      </div>
                      <div className="contact2 clearfix">
                        <div className="address">
                          <div className="icon"><i className="fa fa-map-marker"></i></div>
                          <div className="content">
                            <div className="number"><span>607 Fenster Hall</span></div>
                          </div>
                        </div>
                      </div>


                    </div>

                    <div className="details">
                      <div className="tabbed-content" data-tabbed-content="1" role="tablist">
                        <nav className="tabbed-nav scrolling"><div className="nav-scroll">
                          <div className="wide-load">
                            <a data-target="tab-1" className="tab-control tab-control-other-info" data-tabs-group="tab-group">Other Info</a>
                          </div>
                          <div className="bottom-line"></div>
                        </div>
                          <div className="scroll-shade"></div>
                        </nav>
                        <div className="tab-content" rel="tab-1">

                          <div className="items">
                            <div className="item clearfix">
                              <div className="label">
                                Regions
                              </div>
                              <div className="desc">
                                Monmouth, Somerset, Union, Hunterdon, Warren, Sussex Counties, Staten Island, Western Pennsylvania, Midwestern U.S.
                              </div>
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>

                  </div>
                </div>

              </div>
            </div>

          </div>
        </div>
      </div>
      </div>
    </div>

        </Modal>
    
  <h3 className="title">
    Questions? <br className="desktop-only" />
    Find your admissions counselor
  </h3>
    
  <p className="description">Our team of admissions counselors can help you with your application, financial aid, or answer any questions you might have about what life at NJIT is like.</p>

  <button className="button button-your-admissions-counselor" onClick={this.openModal}>
    Find Your Counselor
  </button>



</div>
</div>

    );
  }
}


FindYourCounselor.propTypes = {
  /*size: PropTypes.number,
  from: PropTypes.number,
  sortOrder: PropTypes.string,
  sortField: PropTypes.string,
  query: PropTypes.string,
 
  // A value of any data type
  site: PropTypes.string.isRequired,
  contentType: PropTypes.string.isRequired,
  subheader: PropTypes.string.isRequired,
  header: PropTypes.string.isRequired,
  keywords: PropTypes.array.isRequired,*/
};

export default FindYourCounselor;






// WEBPACK FOOTER //
// ./src/FindYourCounselor/FindYourCounselor.js